import { isAnnotationComplete } from "@pathwright/blocks-core/src/blocks/annotatedassessment/block-type"
import {
  BLOCK_INPUT_STATES,
  useBlockCompletion,
  useBlocksConfig
} from "@pathwright/blocks-engine"
import { ImageEdit, SubText } from "@pathwright/blocks/src/shared"
import Button from "@pathwright/ui/src/components/button/Button"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import get from "lodash/get"
import React, { useEffect } from "react"
import styled from "styled-components"
import QuestionHeader from "../Question/QuestionHeader"
import { QuestionWrapper } from "./ui"

const StyledContentContainer = styled(Content.Container)`
  .BlockImage {
    cursor: ${(p) =>
      p.disableInput ? `not-allowed !important;` : `crosshair !important;`};
  }
`

const StyledAnnotationsMeta = styled.div`
  margin-bottom: 1rem;
  margin-top: 1rem;
  display: flex;

  .ContentText.ql-editor {
    width: auto;
  }
`

const AnnotatedAssessmentView = (props) => {
  const { data, onChange } = props

  const { t } = useTranslate()
  const { setBlockFunctions, setUseAutocomplete, getBlurProps } =
    useBlockCompletion()

  const { templateVariables, disableInput } = useBlocksConfig()

  useEffect(() => {
    setUseAutocomplete(true)
    setBlockFunctions({
      validateInput,
      getBlockIsCompleted: isAnnotationComplete
    })
  }, [])

  const getAnnotations = (passedData = null) => {
    return get(passedData || data, "answer.selectedAnnotations", [])
  }

  const validateInput = (data) => {
    const annotations = getAnnotations(data)
    if (!annotations.length) return BLOCK_INPUT_STATES.NONE

    return !data.requiredCount || annotations.length >= data.requiredCount
      ? BLOCK_INPUT_STATES.VALID
      : BLOCK_INPUT_STATES.INVALID
  }

  const handleClearAllAnnotations = () => {
    onChange({ answer: { ...data.answer, selectedAnnotations: [] } }, true)
  }

  const handleChangeAnnotation = (annotations) => {
    const prevAnswer = data.answer || { selectedAnnotations: [] }

    if (data.requiredCount && annotations.length > data.requiredCount) return

    const answer = {
      ...prevAnswer,
      selectedAnnotations: annotations
    }
    onChange({ answer }, true)
  }

  const { total, current } = {
    total: data.requiredCount,
    current: getAnnotations(data).length
  }

  return (
    <StyledContentContainer
      className="AnnotatedAssessmentView"
      disableInput={disableInput}
    >
      <QuestionWrapper {...getBlurProps()}>
        <QuestionHeader {...props} />
        {!!data.requiredCount && (
          <StyledAnnotationsMeta>
            <SubText
              html={`<span>${t(
                `blocks.annot_assess.${
                  current >= total ? "all_added" : "completed"
                }`
              )} (${current}/${total})</span>`}
              templateContext={templateVariables}
            />
            {!!current && !disableInput && (
              <React.Fragment>
                <span style={{ fontSize: "1.5rem", margin: "-3px 5px 0" }}>
                  {" "}
                  •{" "}
                </span>
                <Button
                  className="reset-button blank"
                  onClick={handleClearAllAnnotations}
                  styleType="blank"
                  preIcon="arrow-back-circle"
                  label={t("blocks.annot_assess.reset")}
                ></Button>
              </React.Fragment>
            )}
          </StyledAnnotationsMeta>
        )}
      </QuestionWrapper>
      <ImageEdit
        image={data.src}
        altText={data.altText}
        caption={data.caption}
        captionEnabled={!!data.caption}
        annotationsEnabled
        annotationsOnly={!disableInput}
        annotations={getAnnotations(data)}
        onChangeAnnotations={handleChangeAnnotation}
        atMaxAnnotations={total && current > total ? true : false}
        readOnly
      />
    </StyledContentContainer>
  )
}

export default AnnotatedAssessmentView
